<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">{{ $t('table_title.Chapter') }}</h5>
                            </a-col>
                        </a-row>
                    </template>
                    <template>
                        <v-data-table
                            :headers="hiddenColTable"
                            :items="chapters"
                            class="elevation-1"
                            show-select
                            v-model="selected"
                            hide-default-footer
                            :loading="isLoadingChapter"
                            :loading-text="$t('cms.loading')"
                            :page="page"
                            :no-data-text="$t('cms.no_data_available')"
                        >
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-dialog v-model="dialogCU" persistent max-width="500px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="primary" dark class="mr-2" @click="onAddNewItem()" small>
                                                <v-icon small> mdi-plus </v-icon>
                                                {{ $t('cms.add_new') }}
                                            </v-btn>
                                            <v-btn
                                                color="error"
                                                dark
                                                class="mr-2"
                                                small
                                                v-show="selected.length > 0"
                                                @click="onDeleteMulti"
                                            >
                                                <v-icon small> mdi-delete </v-icon>
                                                &nbsp;{{ $t('form.delete') }}
                                            </v-btn>
                                        </template>

                                        <ChapterModal
                                            :cuItem="cuItem"
                                            :formTitle="formTitle"
                                            :closeCU="closeCU"
                                            :save="onSaveItem"
                                            :propsField="propsField"
                                            :columns="tableColumns"
                                            :dialogEdit="dialogEdit"
                                            v-if="dialogCU"
                                        >
                                        </ChapterModal>
                                    </v-dialog>

                                    <v-spacer></v-spacer>

                                    <div class="search">
                                        <a-select :default-value="selectedField" @change="handleChangeSelect">
                                            <a-select-option
                                                v-for="(item, index) in fieldsSearch"
                                                :key="index"
                                                :value="item.value"
                                            >
                                                {{ item.title }}
                                            </a-select-option>
                                        </a-select>
                                        <a-input-search
                                            v-model="search"
                                            :placeholder="$t('header.search')"
                                            @change="onSearchItem"
                                        />
                                    </div>

                                    <v-dialog v-model="dialogDelete" max-width="500px">
                                        <ModalDelete :closeDelete="closeDelete" :deleteItemConfirm="deleteItemConfirm">
                                        </ModalDelete>
                                    </v-dialog>
                                    <v-dialog v-model="dialogNoti" max-width="500px">
                                        <ModalNoti :close="closeNoti" :message="formMessage"></ModalNoti>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.title`]="{ item }">
                                <div class="my-2 line-clamp-2">
                                    <span>{{ item.title }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.created_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{ getFormatDate(+item.created_at_unix_timestamp) }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.updated_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{ getFormatDate(+item.updated_at_unix_timestamp) }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <router-link :to="{ path: `/sections?chapter_id=${item.id}` }">
                                    <v-btn color="indigo" class="mr-2" dark small>
                                        <v-icon left> mdi mdi-format-list-bulleted-type </v-icon>
                                        {{ $t('cms.show_section') }}
                                    </v-btn>
                                </router-link>
                                <v-btn color="success" dark class="mr-2" small @click="onDuplicate(item)">
                                    <v-icon small> mdi-content-copy </v-icon>
                                    &nbsp;{{ $t('form.duplicate') }}
                                </v-btn>
                                <v-btn color="info" class="mr-2" small @click="onUpdateItem(item)">
                                    <v-icon small> mdi-pencil </v-icon>
                                    &nbsp;{{ $t('form.edit') }}
                                </v-btn>
                                <v-btn color="error" dark small @click="onDeleteItem(item)">
                                    <v-icon small> mdi-delete </v-icon>
                                    &nbsp;{{ $t('form.delete') }}
                                </v-btn>
                            </template>
                        </v-data-table>
                        <div class="text-center py-5">
                            <f-pagination
                                v-model="page"
                                :pageSize="chaptersPagination.pageSize"
                                :totalItems="chaptersPagination.totalItems"
                                :disabled="isLoadingChapter"
                            />
                        </div>
                    </template>
                </a-card>
            </a-col>
        </a-row>
        <f-notification-dialog
            class="dialogNoti"
            :isShowDialog="isShowDialogDuplicate"
            width="500px"
            :title="$t('cms.duplicating_chapter')"
            content=""
            :actions="actionsLogout"
        />
        <f-notification-dialog
            class="dialogNoti"
            :isShowDialog="isShowDialogMulti"
            width="500px"
            :title="$t('cms.delete_multiple')"
            :content="$t('cms.confirm_delete_multiple')"
            :actions="actionsMulti"
        />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ChapterModal from '../../components/CMS/Modal/Chapter.vue';
import ModalDelete from '../../components/CMS/Modal/Delete.vue';
import ModalNoti from '../../components/CMS//Modal/Noti.vue';
import { CRUD } from '../../constants';
import { mixinToasts, mixinFormats, mixinLoadings } from '../../mixins';
import * as _ from 'lodash';

export default {
    mixins: [mixinToasts, mixinFormats, mixinLoadings],
    components: { ChapterModal, ModalDelete, ModalNoti },

    data() {
        return {
            tableTitle: this.$t('cms.chapter_table'),
            tableColumns: [
                { text: this.$t('form.title'), value: 'title', sortable: false, width: '300px' },
                {
                    text: this.$t('form.created_at'),
                    value: 'created_at_unix_timestamp',
                    sortable: false,
                    width: '175px',
                },
                {
                    text: this.$t('form.updated_at'),
                    value: 'updated_at_unix_timestamp',
                    sortable: false,
                    width: '175px',
                },
                { text: this.$t('cms.action'), value: 'actions', sortable: false, width: '400px' },
            ],
            fieldsSearch: [
                {
                    title: this.$t('form.title'),
                    value: 'title',
                },
            ],
            selectedField: 'title',
            search: '',
            page: 1,
            cuIndex: -1,
            cuItem: {},
            cuItemDelete: {},
            dialogCU: false,
            dialogDelete: false,
            dialogNoti: false,
            dialogEdit: false,
            isShowDialogMulti: false,
            actionsMulti: [],
            selected: [],
            noImage: require('../../assets/images/no_image.jpg'),
            formMessage: '',

            isShowDialogDuplicate: false,
            actionsLogout: [],
        };
    },
    created() {
        this.hiddenFieldModal(this.dialogEdit);
    },
    computed: {
        ...mapState('chapter', ['isLoadingChapter', 'chapters', 'chaptersPagination']),
        formTitle() {
            return this.cuIndex === -1 ? this.$t('cms.new_item') : this.$t('cms.edit_item');
        },
        hiddenColTable() {
            return this.tableColumns.filter((s) => s.value !== 'password');
        },
    },
    async mounted() {
        await this.getChapterList({ page: this.page, field: this.selectedField, search: this.search });
    },
    watch: {
        page(val) {
            this.getChapterList({ page: val, field: this.selectedField, search: this.search });
        },
        dialogCU(val) {
            val || this.closeCU();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
        dialogNoti(val) {
            val || this.closeNoti();
        },
        dialogEdit(val) {
            this.hiddenFieldModal(val);
        },
    },
    methods: {
        ...mapActions('chapter', [
            'getChapters',
            'postNewChapter',
            'putOneChapter',
            'deleteOneChapter',
            'deleteMultiChapters',
            'duplicateChapter',
        ]),
        async getChapterList(data) {
            this.page = data?.page || 1;
            this.selectedField = data?.field;
            this.search = data?.search || '';
            await this.getChapters(data);
        },
        hiddenFieldModal(val) {
            if (val === true) {
                this.propsField = this.tableColumns.filter(
                    (s) => s.value !== 'password' && s.value !== 'created_at' && s.value !== 'updated_at',
                );
            } else {
                this.propsField = this.tableColumns.filter((s) => s.value !== 'created_at' && s.value !== 'updated_at');
            }
        },
        onAddNewItem() {
            this.dialogEdit = false;
            this.dialogCU = true;
        },
        onUpdateItem(item) {
            this.dialogEdit = true;
            this.dialogCU = true;
            this.cuIndex = this.chapters.indexOf(item);
            this.cuItem = Object.assign({}, item);
        },
        onDeleteItem(item) {
            this.cuIndex = this.chapters.indexOf(item);
            this.cuItemDelete = Object.assign({}, item);
            this.dialogDelete = true;
        },
        onDeleteMulti() {
            this.isShowDialogMulti = true;
            this.actionsMulti = [
                {
                    title: this.$t('cancel'),
                    function: this.cancelMulti,
                },
                {
                    title: this.$t('yes'),
                    function: this.agreeMulti,
                },
            ];
        },
        async agreeMulti() {
            this.isShowDialogMulti = false;
            this.showLoading();
            const arr = this.selected.map((item) => item.id);
            if (arr.length > 0) {
                const res = await this.deleteMultiChapters(JSON.stringify(arr));
                if (res?.isSuccess) {
                    this.selected = [];
                    await this.getChapterList({ page: this.page, field: this.selectedField, search: this.search });
                    this.showSuccess(CRUD.DELETE);
                } else {
                    this.showError(res?.data);
                }
            }
            this.hideLoading();
        },
        cancelMulti() {
            this.isShowDialogMulti = false;
        },
        onDuplicate(item) {
            this.cuItem = Object.assign({}, item);
            this.isShowDialogDuplicate = true;
            this.actionsLogout = [
                {
                    title: this.$t('cancel'),
                    function: this.cancelDuplicate,
                },
                {
                    title: this.$t('yes'),
                    function: this.onDuplicateItem,
                },
            ];
        },
        async onDuplicateItem() {
            this.isShowDialogDuplicate = false;
            this.showLoading();
            const res = await this.duplicateChapter(this.cuItem.id);
            if (res?.isSuccess) {
                await this.getChapterList({ page: this.page, field: this.selectedField, search: this.search });
                this.showSuccess(CRUD.CREATE);
            } else {
                this.showError(res?.data);
            }
            this.hideLoading();
        },
        cancelDuplicate() {
            this.isShowDialogDuplicate = false;
        },
        async deleteItemConfirm() {
            this.closeDelete();
            this.showLoading();
            const res = await this.deleteOneChapter(this.cuItemDelete.id);
            if (res?.isSuccess) {
                await this.getChapterList({ page: this.page, field: this.selectedField, search: this.search });
                this.showSuccess(CRUD.DELETE);
            } else {
                this.showError(res?.data);
            }
            this.hideLoading();
        },
        closeCU() {
            this.dialogCU = false;
            this.$nextTick(() => {
                this.cuItem = Object.assign({}, this.defaultItem);
                this.cuIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.cuItemDelete = Object.assign({}, this.defaultItem);
                this.cuIndex = -1;
            });
        },
        closeNoti() {
            this.dialogNoti = false;
        },
        async onSaveItem(callback) {
            this.showLoading();
            if (this.cuIndex === -1) {
                const res = await this.postNewChapter(this.cuItem);
                callback(res?.isSuccess);
                if (res?.isSuccess) {
                    await this.getChapterList({ page: 1, field: 'title', search: '' });
                    this.showSuccess(CRUD.CREATE);
                } else {
                    this.showError(res?.data);
                }
            } else {
                const res = await this.putOneChapter(this.cuItem);
                callback(res?.isSuccess);
                if (res?.isSuccess) {
                    await this.getChapterList({ page: this.page, field: this.selectedField, search: this.search });
                    this.showSuccess(CRUD.UPDATE);
                } else {
                    this.showError(res?.data);
                }
            }
            this.hideLoading();
        },
        onSearchItem: _.debounce(function (e) {
            this.getChapterList({ page: 1, field: this.selectedField, search: this.search });
        }, 500),
        handleChangeSelect(value) {
            this.getChapterList({ page: 1, field: value, search: this.search });
        },
    },
};
</script>

<style lang="scss">
.search {
    & .ant-select {
        margin-right: 10px;
        width: 120px;
    }

    & .ant-input-search {
        width: 500px;
    }
}
</style>
